<template>
  <div class="flex flex-col mx-auto">
    <HeaderBar :auto-hidden="headerAutoHidden"></HeaderBar>
    <AppMain></AppMain>
    <FooterBar></FooterBar>
  </div>
</template>

<script>
import {AppMain, HeaderBar, FooterBar} from './components'
export default {
  name: 'Layout',
  components: {AppMain, HeaderBar, FooterBar},
  data() {
    return { }
  },
  computed: {
    headerAutoHidden() {
      let auto = this.$route.meta.headerAutoHidden || false;
      return auto;
    },
  },
  methods: {

  }
}
</script>
